// class to generate usersToCalendarObjects map

// Import libraries
const Joi = require('joi');

// Import variables
const { STATES, USER_TYPES, CALENDAR_OBJECT_OWNER_TYPES, CALENDAR_OBJECT_TYPES, CALENDAR_OBJECT_RESPONSE_TYPES } = require('@bcm/constants');
const { MapTableBase } = require('./base.class');
const { joiValidateObj, identifiers } = require('../datastructComponents');

// Create schema
const schema = {
  identifier: Joi.any().optional(),
  userState: Joi.string().valid( ...Object.keys(STATES) ).required(),
  calendarObjectState: Joi.string().valid( ...Object.keys(STATES) ).required(),
  userType: Joi.string().valid( ...Object.keys(USER_TYPES) ).required(),
  userId: Joi.string().required(),
  ownerType: Joi.string().valid( ...Object.keys( CALENDAR_OBJECT_OWNER_TYPES ) ).required(),
  ownerId: Joi.string().required(),
  calendarObjectType: Joi.string().valid( ...Object.keys( CALENDAR_OBJECT_TYPES ) ).optional(),
  calendarObjectId: Joi.string().required(),
  response: Joi.string().valid( ...Object.keys( CALENDAR_OBJECT_RESPONSE_TYPES) ).optional(),
};

// Define class
class UsersToCalendarObjects extends MapTableBase {
  constructor ( obj ) {
    joiValidateObj(schema, obj);
    super (
      identifiers.usersToCalendarObjects.buildPk(obj.userState, obj.userType, obj.userId),
      // NOTE: SK uses userType and userId, NOT ownerType and ownerId to enable user to get their own objects and scan by rule/start (calendar object id)
      identifiers.usersToCalendarObjects.buildSk(obj.calendarObjectState, obj.userType, obj.userId, obj.calendarObjectType, obj.calendarObjectId),
      identifiers.usersToCalendarObjects.buildGsiPk(obj.calendarObjectState, obj.ownerType, obj.ownerId, obj.calendarObjectType, obj.calendarObjectId),
      identifiers.usersToCalendarObjects.buildGsiSk(obj.userState, obj.userType, obj.userId),
    );
    for (const key of Object.keys(obj)) {
      if(obj[key] || obj[key] === false) {
        this[key] = obj[key];
      }
    }
  }
}

exports.UsersToCalendarObjects = UsersToCalendarObjects;
exports.usersToCalendarObjectsSchema = schema;